import { jsx as _jsx } from "react/jsx-runtime";
import { mediaContext, useMediaQueryMatches } from 'hooks/UI';
export const MediaContextProvider = ({ children }) => {
    const ctx = useMediaQueryMatches();
    return _jsx(mediaContext.Provider, Object.assign({ value: ctx }, { children: children }));
};
